// src/components/BackButton.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const BackButton = ({ className = '' }) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      className={`
        group flex items-center gap-2 px-3 py-2 
        text-gray-600 hover:text-gray-900
        bg-white hover:bg-gray-50
        border border-gray-200 hover:border-gray-300
        rounded-lg shadow-sm 
        transition-all duration-200
        ${className}
      `}
      title="Go back"
    >
      <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-0.5" />
      <span className="text-sm font-medium">Back</span>
    </button>
  );
};

export default BackButton;